import React from 'react';
import {DataTable} from '../../../../shared';
import {FundraiserModel} from '../../model';
import {TableColumnConfig} from '@gravity-ui/uikit';

interface BaseFundraiserTableProps {
  fundraisers: FundraiserModel[];
  isLoading: boolean;
  columns: TableColumnConfig<FundraiserModel>[];
  skeletonRowCount?: number;
  onRowClick?: (fundraiser: FundraiserModel) => void;
}

export const BaseFundraiserTable = ({
  fundraisers,
  isLoading,
  columns,
  skeletonRowCount = 5,
  onRowClick,
}: BaseFundraiserTableProps) => {
  return (
    <DataTable<FundraiserModel>
      isLoading={isLoading}
      data={fundraisers || []}
      columns={columns}
      edgePadding={false}
      skeletonRowCount={skeletonRowCount}
      onRowClick={onRowClick}
      emptyStateTitle="Сбор не найдены"
      emptyStateDescription="Сбор с таким названием не найден. Попробуйте изменить запрос"
    />
  );
};
